import { styled } from "styled-components";

export const BoardDetailContainer = styled.div``;
export const BoardDetailWrapper = styled.div`
  padding: 80px 0;
  @media all and (max-width: 768px) {
    padding: 9.115vw 0;
  }
`;
export const BoardDetailWrap = styled.div``;

export const BoardDetailTitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: left;
  padding-bottom: 40px;
  border-bottom: 1px solid #dfdfdf;
  h6 {
    font-size: 24px;
    line-height: 1.3;
    color: #555;
    font-weight: bold;
  }
  p {
    font-size: 14px;
    line-height: 1.4;
    color: #6f6f6f;
  }
  @media all and (max-width: 768px) {
    gap: 2.083vw;
    padding-bottom: 5.208vw;
    h6 {
      font-size: 4.427vw;
    }
    p {
      font-size: 3.385vw;
    }
  }
`;

export const BoardContentsWrap = styled.div`
  padding: 40px 0;
  margin-bottom: 64px;

  text-align: left;
  font-size: 16px;
  line-height: 1.5;
  color: #555;
  display: flex;
  flex-direction: column;
  gap: 40px;
  .img-wrap {
    width: fit-content;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    i {
      overflow: hidden;
      border-radius: 20px;
      border: 1px solid #efefef;

      display: flex;
      align-items: center;
      width: 560px;
      height: 600px;
      img {
        width: 100%;
        height: auto;
        object-fit: cover;
      }
    }
  }
  @media all and (max-width: 768px) {
    padding: 6.51vw 0 3.906vw;
    margin-bottom: 6.51vw;
    font-size: 3.646vw;
    gap: 3.906vw;
    .img-wrap {
      border-radius: 3.906vw;
      gap: 10px;
      i {
        width: 100%;
        height: auto;
        /* height: 71.615vw; */
      }
    }
  }
`;

export const BoardButtonWrap = styled.div`
  display: flex;
  justify-content: center;
  p {
    cursor: pointer;
    width: 134px;
    height: 44px;
    border-radius: 40px;
    background-color: #171717;
    color: #fbfbfb;
    font-size: 20px;
    line-height: 1.4;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @media all and (max-width: 768px) {
    p {
      width: 20.052vw;
      height: 7.031vw;
      border-radius: 2.604vw;
      font-size: 3.646vw;
    }
  }
`;
